import React from 'react';
import {
  Box,
  Typography,
  Button,
  Dialog,
  DialogContent,
  DialogActions
} from '@mui/material';
import {
  CheckCircle as CheckCircleIcon
} from '@mui/icons-material';

interface BookingSuccessModalProps {
  open: boolean;
  onClose: () => void;
  eventTitle?: string;
}

const BookingSuccessModal: React.FC<BookingSuccessModalProps> = ({
  open,
  onClose,
  eventTitle
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          boxShadow: '0 8px 32px rgba(0,0,0,0.1)'
        }
      }}
    >
              <DialogContent sx={{ textAlign: 'center', py: 6, px: 4 }}>
          <Box
            sx={{
              width: 100,
              height: 100,
              borderRadius: '50%',
              bgcolor: 'primary.main',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              mx: 'auto',
              mb: 3
            }}
          >
            <CheckCircleIcon 
              sx={{ 
                fontSize: 60, 
                color: '#FFD700'
              }} 
            />
        </Box>
        <Typography 
          variant="h5" 
          component="h2" 
          gutterBottom
          sx={{ 
            fontWeight: 700,
            color: 'primary.main',
            mb: 2
          }}
        >
          Booking Successful!
        </Typography>
        <Typography 
          variant="subtitle1" 
          color="text.secondary"
          sx={{ 
            fontSize: '1.1rem',
            lineHeight: 1.6,
            mb: 3
          }}
        >
          You have successfully booked for <b>{eventTitle}</b>. We look forward to seeing you there!
        </Typography>
        <Typography 
          variant="body2" 
          color="text.secondary"
          sx={{ 
            fontStyle: 'italic',
            mb: 1
          }}
        >
          A confirmation email has been sent to your registered email address.
        </Typography>
      </DialogContent>
              <DialogActions sx={{ justifyContent: 'center', pb: 4, px: 4 }}>
                  <Button
            variant="contained"
            color="primary"
            onClick={onClose}
            sx={{ 
              px: 6,
              py: 1.5,
              borderRadius: 2,
              textTransform: 'none',
              fontSize: '1.1rem',
              fontWeight: 600,
              boxShadow: '0 4px 12px rgba(99, 102, 241, 0.2)',
              '&:hover': {
                boxShadow: '0 6px 16px rgba(99, 102, 241, 0.3)'
              }
            }}
          >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default BookingSuccessModal;
